import { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Image, ListItem, LoadingBubbles, StatusBadge, Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import type { CampaignSearchResult, InitFormState } from '@modals/ImportCampaignModal/hooks/useImportCampaign'
import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'

import defaultImage from '../../assets/default_campaign_image_75x75.png'

interface SearchResultProps {
  callbacks: {
    closeModal: () => void,
    importCampaign: (payload: HandleCallbackActionParams) => void,
    importFn: () => void,
  },
  entityState: InitFormState,
  result: CampaignSearchResult,
}

const SearchResult = (props: SearchResultProps) => {
  const {
    callbacks: {
      closeModal,
      importCampaign,
      importFn,
    },
    entityState: {
      agency_id,
      sale_method,
    },
    result,
    result: {
      address,
      id,
      status,
    },
  } = props

  const imageUrl = digObject(result, 'images.thumb', defaultImage)

  const [loading, setLoading] = useState(false)

  const importCampaignPayload = {
    callbacks: {
      action: importFn,
      afterAction: () => {
        setLoading(false)
        closeModal()
      },
      afterError: () => setLoading(false),
    },
    entityParams: {
      agency_id,
      id,
      sale_method,
    },
    shouldRedirect: true,
    toastText: 'Campaign Imported',
  }

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        paddingLeft: 0,
        minHeight: '74px',
        marginBottom: 'medium',
        padding: 'large',
      }}
      forceBottomBorder
      onClick={() => {
        setLoading(true)
        // @ts-expect-error TS2345
        importCampaign(importCampaignPayload)
      }}
    >
      <>
        {loading && <LoadingBubbles color="blue" /> }

        {!loading && (
          <>
            <Box variant="center" width="fit-content">
              {/*
               // @ts-expect-error TS2322 */}
              <Image circle width={40} url={imageUrl} placeholder={defaultImage} />
            </Box>

            <Box alignItems="center" marginLeft="medium">
              <Box flexDirection="column" justifyContent="center">
                <Text fontSize="small">{address}</Text>

                <Box flexWrap="wrap" marginTop={status ? 'small' : ''}>
                  {!!status && (
                    <StatusBadge
                      boxProps={{ marginRight: 'medium' }}
                      color="blue"
                      ghost
                      text={status}
                    />
                  )}

                  <Text color="lightGrey" fontSize="xsmall" marginTop="small">
                    ID #{id}
                  </Text>
                </Box>
              </Box>

              <FontAwesomeIcon icon={faCirclePlus} />
            </Box>
          </>
        )}
      </>
    </ListItem>
  )
}

export default SearchResult
